export const setVis = async (object, isVisible, excludes = []) => {
    object.traverse((child) => {
        child.visible = isVisible && !excludes.some((exclude) => child.name.includes(exclude));
    });
    return;
};
